import { MapGroupId } from "../../types";
import img from "../../mapImages/Woods3D.webp";

const mapData = {
  groupId: MapGroupId.Woods,
  groupName: {
    en: "Woods",
    ru: "Лес ",
  },
  title: {
    en: "Main 3D",
    ru: "Главная 3D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
